import { awaitJSON, NexxenLambdaFetch } from '../../utils/fetch-utils';
import { nexxenIOUrl } from '../../utils/nexxen/nexxen-constants';

// The agent-drafted PAUSED Nexxen insertion orders for a company, from the
// bpm-lambdas getPendingNexxenCampaigns endpoint (created_by = automation,
// status 'draft'). Company-scoped server-side. Parallel to the direct-IO
// approvals fetch — a different table/shape, so its own module + query.

export interface PendingNexxenCampaign {
  id: number;
  campaign_name: string;
  nexxen_io_id: string;
  advertiser_id: string;
  status: string;
  media_budget: number;
  flight_start_date: string;
  flight_end_date: string;
  company: string;
}

const NEXXEN_CAMPAIGNS_PENDING = '/campaigns/pending';
const NEXXEN_CAMPAIGNS = '/campaigns';
export const NEXXEN_QUERY_KEY = 'nexxenCampaignsPending';

// Delete one agent-drafted Nexxen draft (removes it from this panel — the list is
// a pure read of the same table). Company-scoped + automation/draft-guarded
// server-side. The paused Nexxen IO in the Nexxen platform is unaffected.
export const deletePendingNexxenCampaign = async (company: string, id: number): Promise<void> => {
  await NexxenLambdaFetch(NEXXEN_CAMPAIGNS, {
    method: 'DELETE',
    params: { company, id: String(id) }
  });
};

export const fetchPendingNexxenCampaigns = async (
  company: string
): Promise<PendingNexxenCampaign[]> => {
  const res = await NexxenLambdaFetch(NEXXEN_CAMPAIGNS_PENDING, {
    params: { company }
  });
  const body = await awaitJSON<{ pending: PendingNexxenCampaign[] }>(res);
  return body.pending ?? [];
};

// The Nexxen (Amobee) console deep-link for an insertion order's packages —
// confirmed pattern from an ad-ops test IO (Harry, 2026-08-10):
//   https://platform.amobee.com/webapp/#/io-dashboard/{ioId}/packages
// A read-only deep-link out to the DSP console; it never sends or activates
// anything. There is no Elevate advertiser in Nexxen until that account is
// created, so the linked IO only resolves once the paused $1-capped Elevate IOs
// exist — the pattern itself is now correct, so no further code change is needed.
export const nexxenConsoleUrl = (io: PendingNexxenCampaign): string => nexxenIOUrl(io.nexxen_io_id);
